import type { TFunction } from 'i18next';

export const getExpireSoonTitle = (t: TFunction, daysRemaining: number): string => {
  if (daysRemaining === 0) return t('Segment is going to expire today');

  return t('Segment is going to expire within the next {count} {dayLabel}', {
    count: daysRemaining,
    dayLabel: t(daysRemaining === 1 ? 'day' : 'days'),
  });
};
